module.exports = __webpack_public_path__ + "img/SonicWall-TZ.d1c2614.svg";